import { useQuery } from '@tanstack/react-query';
import { fetchAdminBreakRequestDetail } from './api';

export const ADMIN_BREAK_REQUEST_DETAIL_QUERY_KEY = (requestId: string) =>
  ['discord-activity-admin-break-request-detail', requestId] as const;

/**
 * One-shot lookup for the full admin break-request row (#4201). The
 * pending-break-requests strip carries the privacy-minimum
 * `DiscordActivityPendingBreakRequest`; clicking "Review" opens the drawer
 * which fetches the alias-revealing payload (alias, reason, decisionOptions)
 * via this hook.
 *
 * Polling is not needed — the row is only fetched when the drawer is open,
 * and the snapshot's React Query cache is invalidated by the action mutations
 * to drive close-on-decide. `staleTime: 0` keeps reopens fresh against an
 * already-mutated row without burning a 5s polling slot.
 */
export function useAdminBreakRequestDetail(
  accessToken: string,
  requestId: string | null,
) {
  return useQuery({
    queryKey: requestId ? ADMIN_BREAK_REQUEST_DETAIL_QUERY_KEY(requestId) : ['idle'],
    queryFn: () => fetchAdminBreakRequestDetail(accessToken, requestId!),
    enabled: Boolean(requestId),
    staleTime: 0,
    retry: 1,
  });
}
